import { BaseService, type ResponseMessage } from "@kiddocare-platform/portal-common/base";

export class CommunicationNotificationService extends BaseService {

  public async CountNotices(): Promise<ResponseMessage<{ count: number, date: string }>> {
    try {
      const response = await this.AxiosInstance.get('/parent/notifications/countNotices');
      return response.data;
    } catch (error: any) {
      this.log.error("CountNotices", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async SetReadedAll(): Promise<unknown> {
    try {
      const response = await this.AxiosInstance.put('/parent/notifications/setReadedAll');
      return response.data;
    } catch (error: any) {
      this.log.error("SetReadedAll", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async SetReadedNotice(params: { device?: string, idNotice?: bigint, messageId?: string, }): Promise<any> {
    try {
      const response = await this.AxiosInstance.put('/parent/notifications/setReadedNotice', params);
      return response.data;
    } catch (error: any) {
      this.log.error("SetReadedNotice", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async SearchNotices(params: {
    query: any,
    currentPage: number,
    pageSize: number
  }): Promise<any> {
    try {
      const response = await this.AxiosInstance.post('/parent/notifications/searchNotices', params);
      return response.data;
    } catch (error: any) {
      this.log.error("searchNotices", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async DeleteNotice(idNotice: bigint): Promise<any> {
    try {
      const response = await this.AxiosInstance.delete(`/parent/notifications/deleteNotice/${idNotice}`);
      return response.data;
    } catch (error: any) {
      this.log.error("deleteNotice", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}